module.exports = __webpack_public_path__ + "assets/u101.c1ce2f7b.svg";